import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const OvalIcon = ({/* secondaryColor,  */ ...props}) => {
    return (
        <Icon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M12 1C5.93 1 1 5.93 1 12C1 18.07 5.93 23 12 23C18.07 23 23 18.07 23 12C23 5.93 18.07 1 12 1ZM12 21C7.04 21 3 16.96 3 12C3 7.04 7.04 3 12 3C16.96 3 21 7.04 21 12C21 16.96 16.96 21 12 21Z"
                fill={/*secondaryColor || */ 'currentColor'}
            />
        </Icon>
    )
}

OvalIcon.propTypes = {
    secondaryColor: PropTypes.string,
}

export default OvalIcon
